import { render, staticRenderFns } from "./List.move.vue?vue&type=template&id=623c22d2&scoped=true&lang=html&"
import script from "./List.move.vue?vue&type=script&lang=js&"
export * from "./List.move.vue?vue&type=script&lang=js&"
import style0 from "./List.move.vue?vue&type=style&index=0&id=623c22d2&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623c22d2",
  null
  
)

export default component.exports